import { useState } from "react";
import "./AboutMe.scss";

const AboutMe = () => {
  const [activeContent, setActiveContent] = useState(null);

  const sectionContent = {
    section1: {
      title: "A Little Bit About Me",
      content:
        "My journey into Web Development started for me when I was at University from 2017 - 2020 where I had gained an insight into the world of Web Development. However, during my time at University I had also worked on a bunch of other projects and my dissertation was in Machine Learning!",
    },
    section2: {
      title: "Development Philosophy",
      content:
        "I believe in writing clean, maintainable code that solves real-world problems. My approach combines technical excellence with user-centric design principles. I'm passionate about creating responsive, accessible web applications that provide exceptional user experiences across all devices.",
    },
    section3: {
      title: "Technical Arsenal",
      content:
        "My core expertise lies in modern JavaScript frameworks, particularly React and Angular. I'm proficient in TypeScript, SCSS, and state management solutions like Redux. I follow clean code principles and implement responsive design patterns. My experience includes working with REST APIs, version control (Git), and CI/CD pipelines.",
    },
    section4: {
      title: "Project Highlights",
      content:
        "Throughout my career, I've led and contributed to various significant projects. Notable achievements include developing greenfield applications from scratch, optimising legacy codebases for better performance, and implementing complex UI features that enhanced user engagement. I take pride in delivering solutions that exceed client expectations.",
    },
    section5: {
      title: "Problem-Solving Approach",
      content:
        "When tackling development challenges, I follow a methodical approach: thoroughly understanding requirements, researching best practices, planning the implementation, and iterating based on feedback. I believe in the power of collaboration and always strive to learn from team members while sharing my own knowledge.",
    },
    section6: {
      title: "Future Focus",
      content:
        "I'm currently expanding my knowledge in cloud technologies and serverless architectures. I'm passionate about staying current with emerging web technologies and best practices. My goal is to continue growing as a developer while contributing to projects that make a meaningful impact.",
    },
  };

  const handleSectionClick = (sectionId) => {
    const section = document.getElementById(sectionId);
    const offsetTop = section.offsetTop;
    const line = document.getElementById("line");
    line.style.top = `${offsetTop + 15}px`;

    setActiveContent((prevActive) =>
      prevActive === sectionId ? null : sectionId,
    );
  };

  return (
    <div className="about-me__container">
      <div className="about-me__header">
        <h1 className="about-me__header">About me.</h1>
        <p className="about-me__subheader">
          Front-end developer focused on creating intuitive and performant web
          and mobile experiences.
        </p>
        <div className="about-me__header-underline"></div>
      </div>
      <div className="about-me__sections">
        <div className="about-me__line--container">
          <div className="about-me__line--inner" id="line"></div>
        </div>
        <div className="about-me__content">
          {Object.entries(sectionContent).map(([id, { title, content }]) => (
            <div
              key={id}
              id={id}
              className={`about-me__section ${
                activeContent === id ? "active" : ""
              }`}
              onClick={() => handleSectionClick(id)}
            >
              <h1>{title}</h1>
              <div
                className={`about-me__section-content ${
                  activeContent === id ? "expanded" : ""
                }`}
              >
                <p>{content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
